import { render, staticRenderFns } from "./Question3.vue?vue&type=template&id=0bed75a9"
import script from "./Question3.vue?vue&type=script&lang=js"
export * from "./Question3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports